import { EventCard } from '@/components/megamenu/EventCard';

export const MegaMenuEventsContent = ({ menuItems, upcomingEventData, isLoading }) => {

  return (
    <div className="grid grid-cols-6 gap-2">
      {/* Left Section */}
      <div className="h-[460px] px-3 py-9 bg-[#fcfcff] col-span-3">
        <div className="h-[200px] gap-1">
          {menuItems.map((item, index) => (
            <a
              href={item.href}
              key={index}
              className={`p-5 rounded-lg flex flex-col justify-start items-start gap-2 ${
                item.title === 'CPD Certificate'
                  ? 'opacity-50 cursor-not-allowed pointer-events-none'
                  : 'hover:bg-[#F3F4F8] cursor-pointer'
              }`}
              aria-disabled={item.title === 'CPD Certificate'}
              tabIndex={item.title === 'CPD Certificate' ? -1 : undefined}
            >
              <div className="items-center gap-2">
                <div className="flex items-center gap-2">
                  <div className="w-6 h-6">{item.icon}</div>
                  <div className="mega-menu-submenu-title">{item.title}</div>
                </div>
                <div className="mega-menu-submenu-text">{item.description}</div>
              </div>
            </a>
          ))}
        </div>
      </div>

      {/* Right Section */}
      <div className="h-[460px] px-6 py-8 bg-[#f3f4f8] col-span-3 pt-11 flex flex-col justify-between">
        <div>
          <p className="mega-menu-featured-content-title mb-4">
            Take charge of your development
          </p>
          <p className="resources-featured-content-text mb-5">
            Never let an event slip by. Find the best events to develop your equity release know-how.
          </p>
          <div className="h-[348px] flex-col items-start inline-flex">
            <p className="events-featured-content-text-link mb-2">
              Upcoming Events
            </p>
            <div className="grow shrink basis-0 flex-col items-start flex">
              {isLoading ? (
                <div className="w-full space-y-3 animate-pulse">
                  {[1, 2].map((i) => (
                    <div key={i} className="w-full h-16 bg-gray-300 rounded"></div>
                  ))}
                </div>
              ) : upcomingEventData && upcomingEventData.data && upcomingEventData.data.length > 0 ? (
                upcomingEventData.data.map((event, index) => (
                  <EventCard
                    key={index}
                    event={event}
                  />
                ))
              ) : (
                <div className="text-gray-500 text-sm">No upcoming events available</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
